import React, { ReactElement, useState } from 'react'
import styles from "../../styles/admanager/UserEarningsReport.module.scss"
// import classnames from 'classnames';
// import GenericDropdown from "../../containers/helpers/genericDropdown";
// import GenericTable from '../helpers/genericTable';
import { useSelector } from 'react-redux';
import { getAdboxMonthDateEarnings } from "../../selectors/monetizationSelector";
import { useEffect } from 'react';
// import {WorkState } from "../../reducers/models";
import { useDispatch } from 'react-redux';
import { getAdboxMonthToDate } from '../../actions/monetization';
import ToolTip from '../../components/ToolTip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons/faInfo";


const UserEarningMonthToDate = (props:any):ReactElement => {

  const dispatch = useDispatch();
  const report = useSelector(getAdboxMonthDateEarnings);

  const [earnings, setEarnings ] = useState<string>("$-.--");

  useEffect(() => {
    const generateMonthToDate = (): void => {
      dispatch(getAdboxMonthToDate());
    }

    generateMonthToDate();
  }, [dispatch])

  useEffect(() => {
    setEarnings(convertEarnings(report.earnings));
  }, [report])

  // TODO: possibly move this to it's on gobal helper for different regions to their correct earnings
  // TODO: need to see if the app checks user's region/currency setting to display 
  const convertEarnings = (value:number) => {
    if (isNaN(value)) {
      return "$-.--"
    }
    const newReportEarning = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return (newReportEarning.format(value/100))
  }
  
  return (
    <div className={styles.monthToDate} >
      <h3>This Month Earnings: { earnings }</h3>
      <ToolTip text="This month-to-date amount is an estimate and should not be considered as final, guaranteed, or completely accurate."
      direction="top">
        <FontAwesomeIcon icon={faInfo as any} className={styles.icon}/>
      </ToolTip>

    </div>
  )
}

export default UserEarningMonthToDate
